import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from 'semantic-ui-react';

import { selectStorage, setAutomaticCleanupMode } from 'app/redux/storage/reducer';

export default function StorageDeletionSettings() {
  const automaticCleanupMode = useSelector(selectStorage).automaticCleanupMode;
  const dispatch = useDispatch();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Checkbox
        checked={automaticCleanupMode === 'pacs'}
        onChange={(_e, { checked }) => dispatch(setAutomaticCleanupMode(checked ? 'pacs' : 'none'))}
        label={
          <label>
            <FormattedMessage id="storage.enableDeletePACSOnly.label" />
          </label>
        }
      />
      <Checkbox
        checked={automaticCleanupMode === 'all'}
        onChange={(_e, { checked }) => dispatch(setAutomaticCleanupMode(checked ? 'all' : 'none'))}
        label={
          <label>
            <FormattedMessage id="storage.enableDeleteAll.label" />
          </label>
        }
      />
    </div>
  );
}
